'use client';
import { FormControlProps } from './form-control.interfaces';
import { FormControlStyled } from './form-control.styles';

const FormControl = (props: FormControlProps) => {
  let fullWidth = true;

  if (props.fullWidth != null) {
    fullWidth = props.fullWidth;
  }

  const template: JSX.Element = <FormControlStyled {...props} fullWidth={fullWidth} />;

  return template;
};

export default FormControl;
